import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
var copyEditorFields = {
  TAGLINE: 'tagline',
  HEADING: 'heading',
  BYLINE: 'byline',
  DESCRIPTION: 'description',
  HELP_TEXT: 'helpText',
  FEATURE_IMAGE: 'featureImageAssetRef',
  BACKGROUND_IMAGE: 'backgroundImageAssetRef',
  LINK_TEXT: 'linkText',
  LINK: 'link',
  PRICE: 'price',
  LABEL: 'label',
  CAPTION: 'caption'
};
copyEditorFields.ALL = _valuesInstanceProperty(_).call(_, copyEditorFields);
copyEditorFields.COMMON = _.difference(copyEditorFields.ALL, [copyEditorFields.TAGLINE, copyEditorFields.HELP_TEXT, copyEditorFields.LINK_TEXT, copyEditorFields.BACKGROUND_IMAGE, copyEditorFields.PRICE]);
export default copyEditorFields;
//# sourceMappingURL=copy-editor-fields.js.map